'use client';

import { useSyncActiveFirmWithIdentity } from '../model/use-sync-active-firm-with-identity';

/**
 * Mounted once in the root layout, inside `IdentityProvider`. Renders nothing:
 * it only keeps the tab's active firm in step with identity (WP1.24.8).
 */
export function ActiveFirmIdentitySync() {
  useSyncActiveFirmWithIdentity();
  return null;
}